import { SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';
// components
import Card from '../../../../components/Price/Card/Card';
import Slider from '../../../../components/UI/Slider/Slider';

// style
import style from './price.module.css';

const Price = ({ id }) => {
  const [data, setPrice] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/2');
        const result = await response.json();
        setPrice(result);
      } catch (err) {
        setError('Ошибка загрузки данных');
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Filter price data
  const item = data.filter((card) => card.seo_url_arena == id);

  if (loading) {
    return (
      <section className={style.price}>
        <div className="container">
          <div className={style.error}>
            <div className="loader"></div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className={style.price}>
        <div className="container">
          <div className={style.error}>Ошибка: {error}</div>
        </div>
      </section>
    );
  }

  return (
    <section className={style.price}>
      <div className="container">
        <div className="title">
          <h2>
            Наши <span>цены</span>
          </h2>
          <span>
            Выбери свою игру <b>.</b>
          </span>
        </div>
        {item.length === 0 ? (
          <div className={style.error}>Нет данных для выбранной игры</div>
        ) : (
          <Slider>
            {item.map((card) => (
              <SwiperSlide key={card.id}>
                <Card item={card} />
              </SwiperSlide>
            ))}
          </Slider>
        )}
      </div>
    </section>
  );
};

export default Price;
